import React from 'react';
import { useTheme } from '@veneer/theme';
var useColorSchemeHelper = (on, disabled) => {
  var theme = useTheme();
  return React.useMemo(() => {
    var getMainTheme = () => {
      if (on && !disabled) return 'toggled';
      if (on && disabled) return 'disabled_toggled';
      if (!on && disabled) return 'disabled_untoggled';else return 'untoggled';
    };
    var mainTheme = {
      untoggled: {
        background: 'transparent',
        backgroundActive: theme.palette.neutral.background,
        backgroundHover: theme.palette.neutral.backgroundLight,
        border: theme.palette.neutral.default,
        borderActive: theme.palette.neutral.active,
        borderHover: theme.palette.neutral.hover,
        icon: theme.palette.foreground.default
      },
      toggled: {
        background: theme.palette.primary.default,
        backgroundActive: theme.palette.primary.active,
        backgroundHover: theme.palette.primary.hover,
        border: theme.palette.primary.default,
        borderActive: theme.palette.primary.active,
        borderHover: theme.palette.primary.hover,
        icon: theme.palette.primary.foreground
      },
      disabled_toggled: {
        background: theme.palette.foreground.disabled,
        backgroundActive: 'transparent',
        backgroundHover: 'transparent',
        border: theme.palette.foreground.disabled,
        borderActive: 'transparent',
        borderHover: 'transparent',
        icon: theme.palette.background.container
      },
      disabled_untoggled: {
        background: 'transparent',
        backgroundActive: 'transparent',
        backgroundHover: 'transparent',
        border: theme.palette.foreground.disabled,
        borderActive: 'transparent',
        borderHover: 'transparent',
        icon: theme.palette.foreground.disabled
      }
    };
    return mainTheme[getMainTheme()];
  }, [on, disabled, theme]);
};
export default useColorSchemeHelper;